(() => {
  const BLUE_COLOURS = new Set([
    'hemp ash',
    'khaki',
    'haze blue',
    'apricot',
    'lucent white',
    'light pink',
  ]);

  const HIDDEN_CLASS = 'flg-logo-colour-hidden';
  let syncQueued = false;

  const normalise = (value) => String(value || '').trim().toLowerCase();

  const logoColourFor = (colour) =>
    BLUE_COLOURS.has(normalise(colour)) ? 'Blue' : 'Off White';

  const installStyles = () => {
    if (document.getElementById('flg-logo-colour-styles')) return;

    const style = document.createElement('style');
    style.id = 'flg-logo-colour-styles';
    style.textContent = `
      .variant-option:has(input[data-option-name="Logo Colour"]),
      .gpo-app .gpo-form__group:has(input[name="Logo Colour"]),
      .${HIDDEN_CLASS} {
        display: none !important;
      }
    `;

    (document.head || document.documentElement).appendChild(style);
  };

  const hideLogoColourFields = () => {
    document
      .querySelectorAll('input[data-option-name="Logo Colour"]')
      .forEach((input) => {
        input.closest('.variant-option, fieldset')?.classList.add(HIDDEN_CLASS);
      });

    document
      .querySelectorAll('.gpo-app input[name="Logo Colour"]')
      .forEach((input) => {
        input
          .closest('.gpo-form__group, .gpo-group')
          ?.classList.add(HIDDEN_CLASS);
      });
  };

  const selectedColour = (root = document) =>
    root.querySelector('input[data-option-name="Colour"]:checked')?.value ||
    root.querySelector('select[data-option-name="Colour"]')?.value ||
    '';

  const chooseRadio = (input) => {
    if (!input || input.checked || input.disabled) return;
    input.click();
  };

  const syncNativeVariantPickers = () => {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      const colour = selectedColour(picker);
      if (!colour) return;

      const wanted = logoColourFor(colour);
      const target = Array.from(
        picker.querySelectorAll('input[data-option-name="Logo Colour"]')
      ).find((input) => input.value === wanted);

      chooseRadio(target);
    });
  };

  const syncGloboOptions = () => {
    const colour = selectedColour();
    if (!colour) return;

    const wanted = logoColourFor(colour);

    document.querySelectorAll('.gpo-app').forEach((app) => {
      const target = Array.from(
        app.querySelectorAll('input[name="Logo Colour"]')
      ).find((input) => input.value === wanted);

      chooseRadio(target);
    });
  };

  const syncAll = () => {
    hideLogoColourFields();
    syncNativeVariantPickers();
    syncGloboOptions();
  };

  const queueSync = () => {
    if (syncQueued) return;
    syncQueued = true;

    requestAnimationFrame(() => {
      syncQueued = false;
      syncAll();
    });
  };

  installStyles();

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-option-name="Colour"]')) return;

    queueSync();
    window.setTimeout(queueSync, 100);
  });

  new MutationObserver(queueSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }
})();